import { useCallback, useMemo } from 'react'
import { toast, ToastOptions, TypeOptions as ToastType } from 'react-toastify'

export const useToast = (theme?: 'light' | 'dark') => {
  const opts: ToastOptions = useMemo(
    () => ({
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: ctx =>
        `${ctx?.defaultClassName} Toastify__toast-theme--${theme || 'light'}`,
    }),
    [theme],
  )

  const addToast = useCallback(
    (type: ToastType, msg: string) => {
      let toastFn = toast.success

      if (type === 'info') {
        toastFn = toast.info
      } else if (type === 'success') {
        toastFn = toast.success
      } else if (type === 'warning') {
        toastFn = toast.warn
      } else if (type === 'error') {
        toastFn = toast.error
      } else {
        toastFn = toast
      }

      toastFn(msg, opts)
    },
    [opts],
  )

  return addToast
}
